export default "<div class=\"spaces-select-container\">\n  <div class=\"spaces-gifs\"></div>\n</div>\n";